<div class="score-bg">
<div class="score-container" *ngIf="analyzing">

 <div class="analyzing-box">
    <div class="spinner"></div>
    <h3>Analyzing Resume</h3>
  <p>Checking compatibility, keywords & ATS score</p>
</div>
</div>


<div class="score-container load"  *ngIf="analyzeData">
  <div class="score-content" [class.hidden]="analyzing">

    <div class="close-btn" (click)="closePopup()">
    <i class="bi bi-x-lg"></i>
  </div>

    <div class="score-header">
      <div class="score-circle">
        <span>{{ analyzeData.score }}</span>
        <small>/100</small>
      </div>

      <div class="score-text">
        <h2>Resume Compatibility Score</h2>
      </div>
    </div>

    <div class="score-cards">
      <div class="card green">
  <h3>✔ Strengths</h3>
  <ul class="strengths-list">
    <li *ngFor="let item of analyzeData.strengths"> {{item}}</li>
  </ul>
     </div>

     <div class="card yellow">
  <h3>⚠ Improvements</h3>
  <ul class="improvements-list">
      <li *ngFor="let item of analyzeData.improvements">
        <p>{{item}}</p>
    </li>
    
  </ul>
    </div>

      <div class="card blue">
        <h3>Missing Keywords</h3>
        <div class="tags">
          <span *ngFor="let item of analyzeData.missingKeywords">{{item}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>